<template>
  <div>
    <SelectPrivate
      :label="itemValue ? '' : '请选择'"
      placeholder=""
      v-model="itemValue"
      :columns="columns"
      :disabled="readonly"
      @update:modelValue="onValueChange()"
    />
    <SpecialValueInput 
      v-if="showOtherInput()"
      v-model="specialValue"
      :disabled="readonly"
      @change="onValueChange()"
    />
  </div>
</template>

<script>
import _ from 'lodash';
import SelectPrivate from '@/view/components/SelectPrivate';
import SpecialValueInput from '../comps/SpecialValueInput.vue';

export default {
  props: {
    item: Object,
    submitValue: Object,
    readonly: Boolean
  },
  emits: ['change'],
  data() {
    return {
      itemValue: null,
      specialValue: null
    };
  },
  computed: {
    columns() {
      return this.optionList.map(v => {
        return {
          id: v.id,
          text: v.name
        }
      });
    },
    optionList() {
      let opArr = [];
      const specialArr = [];
      this.item.option?.map(v => {
        if (v.special) {
          specialArr.push(v);
        } else {
          opArr.push(v);
        }
      });
      if (this.item.random) {
        opArr = _.shuffle(opArr);
      }
      return _.concat(opArr, specialArr);
    },
  },
  components: {
    SelectPrivate,
    SpecialValueInput
  },
  methods: {
    // 【1】itemValue值设置
    setItemValue() {
      const index = this.optionList.findIndex(v => v.id === this.submitValue?.value);
      this.itemValue = index >= 0 ? this.submitValue?.value : null;
      this.specialValue = this.submitValue?.special_value || '';
    },
    // 【2】值监听
    onValueChange() {
      const index  = this.optionList.findIndex(v => v.id === this.itemValue && v.special === 'other');

      this.$emit('change', index >= 0 ? {
        value: this.itemValue,
        special_value: this.specialValue
      } : { value: this.itemValue });
    },
    showOtherInput() {
      const index = this.optionList.findIndex(v => v.special === 'other' && v.id === this.itemValue);
      return index >= 0;
    },
  },
  created() {
    this.setItemValue();
  },
  async mounted() {
    
  },
};
</script>

<style lang="less" scoped>
@import (reference) '@/assets/less/common.less';

</style>
